<template>
  <div class="animated fadeIn">
    <Forms
      ref="frmGroup"
      :title="this.$lang.MyAccount.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onUpdate"
    >
      <div class="form-group row">
        <div class="col-md-12 pt-1">
          <h5 class="text-third">
            <i class="fa fa-lock"></i> {{ $lang.MyAccount.AccessPasswords }}
          </h5>
        </div>
      </div>
      <FormulateForm @submit="onUpdate">
        <div class="row">
          <div class="col-md-4 col-12  mb-3">
            <NxInput
              v-model="form.currentPassword.value"
              label="Senha atual:"
              type="password"
              name="current_password"
              placeholder="Digite sua senha"
              error-behavior="value"
              validation="required"
              :validation-messages="{
                required: 'O campo não deve estar vazio.',
              }"
            />
          </div>
          <div class="col-md-4 col-12 mb-3">
            <NxInput
              v-model="form.newPassword.value"
              label="Nova senha:"
              type="password"
              name="password"
              placeholder="Digite uma senha"
              error-behavior="value"
              :validation-rules="{
                hasNumber: ({ value }) => /\d/.test(value),
                hasLowercase: ({ value }) => /[a-z]/.test(value),
                hasUppercase: ({ value }) => /[A-Z]/.test(value),
                hasSpecialCharacter: ({ value }) => /[!@#$%^&*]/.test(value),
              }"
              validation="required|hasNumber|hasLowercase|hasUppercase|hasSpecialCharacter|min:8,length"
              :validation-messages="{
                required: 'O campo não deve estar vazio.',
                hasNumber: 'Número (0 - 9).',
                hasLowercase: 'Letra minúscula.',
                hasUppercase: 'Letra maiúscula.',
                hasSpecialCharacter: 'Caractere especial (!@#$%&*()+-).',
                min: 'Comprimento mínimo de 8 caracteres.',
              }"
            />
          </div>
          <div class="col-md-4 col-12 mb-3">
            <NxInput
              v-model="form.confirmation.value"
              label="Confirme a senha:"
              type="password"
              name="password_confirm"
              placeholder="Confirme a senha"
              error-behavior="value"
              validation="bail|required|confirm"
              :validation-messages="{
                required: 'O campo não deve estar vazio.',
                confirm: 'As senhas não conferem.',
              }"
              validation-name="Password confirmation"
            />
          </div>
        </div>
      </FormulateForm>

      <div class="form-group row">
        <div class="col-md-12">
          <small class="text-third"
            ><i class="fa fa-info-circle"></i>
            {{ $lang.MyAccount.PasswordOnlyChange }}</small
          >
        </div>
      </div>
      <!-- <hr>
      <span style="font-weight: 700">Requisitos Mínimos:</span>
      <ul>
        <li :class="lengthValid ? 'text-success' : 'text-danger'">
          Comprimento mínimo de 8 caracteres
        </li>
        <li :class="uppercaseValid ? 'text-success' : 'text-danger'">
          Letra maiúscula
        </li>
        <li :class="lowercaseValid ? 'text-success' : 'text-danger'">
          Letra minúscula
        </li>
        <li :class="numberValid ? 'text-success' : 'text-danger'">
          Número (0 - 9)
        </li>
        <li :class="specialCharValid ? 'text-success' : 'text-danger'">
          Caractere especial (!@#$%&*()+-)
        </li>
      </ul> -->
    </Forms>
  </div>
</template>
<script>
import Profile from './profile.js'

export default Profile
</script>



// WEBPACK FOOTER //
// src/views/private/myaccount/profile/profile.vue